export const faqs = [
  {
    question: 'Who is Superluxury for?',
    answer:
      'Individuals, families and companies who value time, privacy and access above all. Many of our clients come to us by introduction, but every request is welcome and reviewed personally.',
  },
  {
    question: 'How quickly can you arrange a request?',
    answer:
      'Most requests — a table, a suite, a car at the door — are confirmed within the hour. Private aviation can be ready in as little as four hours, and larger journeys or events are typically planned within a few days.',
  },
  {
    question: 'Which destinations do you cover?',
    answer:
      'We are on call year-round in Dubai, Monaco, Hamburg and Warsaw, and seasonally in Ibiza, Mallorca and Menorca. Through our partners we also arrange travel and access worldwide.',
  },
  {
    question: 'How is my privacy protected?',
    answer:
      'Every engagement is confidential from the first conversation. We sign a non-disclosure agreement on request, never share your details with partners beyond what a booking requires, and delete your information if no engagement follows.',
  },
  {
    question: 'Can you arrange private aviation, yachts and cars together?',
    answer:
      'Yes. Choose a combination in the request bar — for example private aviation with a yacht transfer — and your partner coordinates every leg as one seamless journey.',
  },
  {
    question: 'How are your services priced?',
    answer:
      'Each request is quoted individually and in writing before anything is booked. There are no hidden fees; partner rates and our arrangement fee are shown clearly in every proposal.',
  },
  {
    question: 'Which payment methods do you accept?',
    answer:
      'All major cards, bank transfer, settlement through your private bank and selected digital assets. Payment details are confirmed with your partner once a proposal is accepted.',
  },
];
